import axios from "axios";
import store from "../store/index";
import * as concertStoreTypes from "../store/modules/concert/types";
import * as types from "../store/modules/common/types";
import * as toolTypes from "../store/modules/tool/types";
import Storage from "./Storage";
import sleep from "await-sleep";
const retryInterval = 1500;
import * as Modal from "../modal/ModalEvent";
import {showBan} from "../modal/ModalEvent";
// import config from '../Config'
// https://s8a.jp/no-cache-using-ajax-with-ie11#axiosの場合
// nocache
axios.interceptors.request.use(function(config) {
  if (typeof config.params === "undefined") {
    config.params = {};
  }
  if (typeof config.params === "object") {
    if (
      typeof URLSearchParams === "function" &&
      config.params instanceof URLSearchParams
    ) {
      config.params.append("_", Date.now());
    } else {
      config.params._ = Date.now();
    }
  }

  return config;
});

const root = store.state.env.apiRoot;

export default class API {
  static test() {
    console.log("store", store.state.env);
    this.login("VPlD5yYg");
  }
  static async login(concertId, retryNum = 2) {
    return await axios
      .post(root + `/consumer/concerts/${concertId}/users`)
      .then(
        res => {
          if (res && res.data && res.data.token) {
            this.setHeader(res.data.token);
            this.sendToken(this.token, concertId);
            console.log("logined");
            return this.token;
          } else {
            return this.retryLogin(concertId, retryNum);
          }
        },
        e => {
          if (this.isNoRetryStatus(e)) {
            return null;
          }
          else return this.retryLogin(concertId, retryNum);
        }
      );
  }
  static async retryLogin(concertId, retryNum, errorText = "api error") {
    console.log(errorText, "retry num", retryNum);
    if (retryNum >= 1) {
      await sleep(retryInterval);
      return await this.login(concertId, --retryNum, result);
    } else {
      Modal.showAPIError("ログインエラー 2");
      return null;
    }
  }

  static async loginArtist(concertId, key, retryNum = 2) {
    return await axios
      .post(root + `/consumer/concerts/${concertId}/artists`, {
        // kind: "artist",
        key: key
      })
      .then(
        res => {
          if (res && res.data && res.data.token) {
            this.setHeader(res.data.token);
            this.sendToken(this.token, concertId);
            Storage.setTabletFlag();
            console.log("artist logined");
            return this.token;
          } else {
            return this.retryLoginArtist(concertId, retryNum);
          }
        },
        e => {
          if (this.isNoRetryStatus(e)) {
            Modal.showAPIError("ログインエラー");
            return null;
          }
          else return this.retryLoginArtist(concertId, retryNum);
        }
      );
  }
  static async retryLoginArtist(
    concertId,
    key,
    retryNum,
    errorText = "api error"
  ) {
    console.log(errorText, "retry num", retryNum);
    if (retryNum >= 1) {
      await sleep(retryInterval);
      return await this.loginArtist(concertId, key, --retryNum, result);
    } else {
      Modal.showAPIError("ログインエラー 2");
      return null;
    }
  }

  static async getConcertInfo(concertId, retryNum = 2) {
    return await axios.get(root + `/consumer/concerts/${concertId}`).then(
      res => {
        store.dispatch(
          concertStoreTypes.namespace + concertStoreTypes.SET_CONCERT_INFO,
          res.data
        );
        console.log("get concert info");
        return res;
      },
      e => {
        if (this.isNoRetryStatus(e)) {
          Modal.showAPIError("コンサート情報が取得できませんでした");
          return null;
        }
        else {
          return this.retryConcertInfo(concertId, retryNum);
        }
      }
    );
  }
  static async retryConcertInfo(
    concertId,
    retryNum = 2,
    errorText = "getConcertInfo error"
  ) {
    console.log(errorText, "retry num", retryNum);
    if (retryNum >= 1) {
      await sleep(retryInterval);
      return await this.getConcertInfo(concertId, --retryNum);
    } else {
      Modal.showAPIError("コンサート情報が取得できませんでした 2");
      return null;
    }
  }

  /**
   * カーソル情報送信。リトライはしない
   * @param data
   * @returns {Promise<AxiosResponse<T>>}
   */
  static async putCursor(data) {
    this.setupHeader();
    const kind = data.type * 10 + data.color;
    return await axios.put(
      root + "/consumer/messages/cursor",
      { x: data.x, y: data.y, kind: kind },
      { headers: API.headers }
    );
  }

  static async checkNGWord(text, retryNum = 2) {
    this.setupHeader();
    return await axios
      .post(
        root + "/consumer/messages/validate_text",
        { text },
        { headers: API.headers }
      )
      .then(
        res => {
          store.dispatch(toolTypes.namespace + toolTypes.ADD_TEXT, text);
          return res;
        },
        e => {
          if (this.isNoRetryStatus(e)) {
            const { status } = e.response;
            if (status != 400 && status != 403) {
              Modal.showAPIError("validate_text");
              return "api error";
            }
            else {
              return false;
            }
          }
          else return this.retryNGWord(text, retryNum);
        }
      );
  }

  static async retryNGWord(text, retryNum = 2, errText = "retryNGWord error") {
    console.log(errText, "retry num", retryNum);
    if (retryNum >= 1) {
      await sleep(retryInterval);
      return await this.checkNGWord(text, --retryNum);
    } else {
      Modal.showAPIError("validate_text");
      return "api error";
    }
  }

  static setHeader(token) {
    console.log("token", token);
    API.headers = {
      authorization: `Bearer ${token}`
    };
    this.token = token;
  }

  static sendToken(token, concertId) {
    store.dispatch(types.namespace + types.SET_USER_ID, { token, concertId });
  }

  /**
   * 画像送信。
   * @param base64_image
   * @param text
   * @param x
   * @param y
   * @param retryNum
   * @returns {Promise<AxiosResponse<T>>}
   */
  static async sendMessage(base64_image, text, x, y, retryNum = 2) {
    if (retryNum < 0) return null;
    base64_image = base64_image.replace(/^data:image\/png;base64,/, "");
    this.setupHeader();
    x = Math.floor(x);
    y = Math.floor(y);
    return await axios
      .post(
        root + "/consumer/messages",
        {base64_image, text, x, y},
        // null,
        {headers: API.headers}
      )
      .then(
        res => {
          Storage.setDrawn(store.state.concert.concertId);
          return res;
        }).catch(e => {
        if (this.isNoRetryStatus(e)) {
          const {status} = e.response;
          if (status != 403)
            Modal.showAPIError("message error");
          throw e;
        } else return this.retrySendMessage(base64_image, text, x, y, retryNum);
      });

  }

  static retrySendMessage(
    base64_image,
    type,
    x,
    y,
    retryNum = 2,
    text = "send message error"
  ) {
    console.log("retry num", retryNum);
    if (retryNum >= 1) {
      setTimeout(() => {
        return this.sendMessage(base64_image, type, x, y, --retryNum);
      }, retryInterval);
    } else {
      Modal.showAPIError("message error 2");
      return null;
    }
  }

  static async deleteMessage(retryNum = 2) {
    // DELETE "/consumer/messages"
    if (retryNum < 0) return null;
    this.setupHeader();
    return await axios
      .delete(root + "/consumer/messages", {
        headers: API.headers
      })
      .then(
        res => {
          return res;
        },
        e => {
          if (this.isNoRetryStatus(e)){
            const { status } = e.response;
            if ( status != 403)
              Modal.showAPIError("delete message error");
            throw e;
          }
          else return this.retryDeleteMessage(retryNum);
        }
      );
  }
  static async toFrontMessage(retryNum = 2) {
    if (retryNum < 0) return null;
    this.setupHeader();
    return await axios
      .post(root + "​/consumer/messages/touch_last", null, {
        headers: API.headers
      })
      .then(
        res => {
          return res;
        },
        e => {
          if (this.isNoRetryStatus(e)) throw e;
          else return this.retryToFront(retryNum);
        }
      );
  }

  static async retryToFront(retryNum = 2, text = "to front message error") {
    console.log(text, "retry num", retryNum);
    if (retryNum >= 1) {
      await sleep(retryInterval);
      return await this.toFrontMessage(--retryNum);
    } else {
      throw new Error("to front error 3");
    }
  }
  static async getMessage(retryNum = 2) {
    if (retryNum < 0) return null;
    this.setupHeader();
    return await axios
      .get(root + "​/consumer/messages/show", {
        headers: API.headers
      })
      .then(
        res => {
          return res;
        },
        e => {
          if (this.isNoRetryStatus(e)) {
            const { status } = e.response;
            if ( status == 401) {
              Modal.showAPIError("show message 401");
            }
            else if (status == 403)
              Modal.showBan();
            else
              throw new Error("show Message: " + status)
            return null;
          }
          else return this.retryGetMessage(retryNum);
        }
      );
  }

  static async retryGetMessage(retryNum = 2, text = "get message error") {
    console.log(text, "retry num", retryNum);
    if (retryNum >= 1) {
      await sleep(retryInterval);
      return await this.getMessage(--retryNum);
    } else {
      throw new Error(text);
      return null;
    }
  }

  static async getCursors(concertId, retryNum = 2) {
    if (retryNum < 0) return null;
    this.setupHeader();
    return await axios
      .get(root + `/consumer/concerts/${concertId}/cursors`, {
        headers: API.headers
      })
      .then(
        res => {
          // TEST code
          // const result = [];
          // for (let i = 0; i < 300; i++) {
          //   result.push({x: Math.random() * 3710, y: Math.random() * 870});
          // }
          // return {data: result};
          return res;
        },
        e => {
          if (this.isNoRetryStatus(e)) {
            const { status } = e.response;
            if ( status == 401) {
              Modal.showAPIError("show get cursor 401");
            }
            return null;
          }
          else return this.retryGetCursors(concertId, retryNum);
        }
      );
  }

  static async retryGetCursors(concertId, retryNum = 2, text = "get get cursor error") {
    console.log(text, "retry num", retryNum);
    if (retryNum >= 1) {
      await sleep(retryInterval);
      return await this.getCursors(concertId, --retryNum);
    } else {
      return null;
    }
  }

  static isNoRetryStatus(e) {
    const { status } = e.response;
    if (status == 403)
      Modal.showBan();
    return status == 400 || status == 401 || status == 403 || status == 404 || status == 405 || status == 500;
  }

  static async retryDeleteMessage(
    retryNum = 2,
    text = "retryDeleteMessage error"
  ) {
    console.log(text, "retry num", retryNum);
    if (retryNum >= 1) {
      await sleep(retryInterval);
      return await this.deleteMessage(--retryNum);
    } else {
      Modal.showAPIError("delete message error 2");
      throw new Error("delete message error 3");
      return null;
    }
  }

  static setupHeader() {
    let token = store.state.common.userId;
    if (token) {
      this.setHeader(token);
    }
  }
}
